import type { EnergyFlow, ScenarioParams } from "../lib/types";
import { kwh, pct } from "../lib/format";

interface Props {
  flow: EnergyFlow;
  scenario: ScenarioParams;
}

interface StatProps {
  label: string;
  value: string;
  accent?: boolean;
  subtle?: boolean;
}

function Stat({ label, value, accent, subtle }: StatProps) {
  const bg = subtle ? "bg-terra-bg" : "bg-bg";
  const border = subtle ? "border-terra-bg" : "border-line";
  const color = accent ? "text-green" : subtle ? "text-rust" : "text-ink";
  return (
    <div className={`${bg} px-3 py-2.5 rounded-md border ${border}`}>
      <div className="label-up mb-1">{label}</div>
      <div className={`mono text-base font-semibold ${color}`}>{value}</div>
    </div>
  );
}

export function FlowSummary({ flow, scenario }: Props) {
  const yt = flow.year_totals;
  const totalProd = flow.months.reduce((s, m) => s + m.production_kwh, 0);
  const totalCons = flow.months.reduce((s, m) => s + m.consumption_kwh, 0);
  const showCurtailable = yt.curtailable_kwh > 0;

  return (
    <div className="grid gap-3 mt-4" style={{ gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))" }}>
      <Stat label="Productie" value={kwh(totalProd)} />
      <Stat label="Verbruik" value={kwh(totalCons)} />
      <Stat label="Eigen verbruik" value={pct(yt.eigen_verbruik_pct, 0)} accent />
      <Stat label="Import" value={kwh(yt.import_kwh)} />
      <Stat label="Export" value={kwh(yt.export_kwh)} />
      {showCurtailable && (
        <Stat
          label={scenario.curtailment_enabled ? "Gecurtailed" : "Curtailbaar"}
          value={kwh(scenario.curtailment_enabled ? yt.curtailed_kwh : yt.curtailable_kwh)}
          subtle
        />
      )}
    </div>
  );
}
